
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/camplejeuneapplication",
      function () {
        return require("private-next-pages/camplejeuneapplication/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/camplejeuneapplication"])
      });
    }
  